// useCooperativaOperativa — ¿sobre QUÉ cooperativa opera la pantalla financiera?
//   • Vista de cooperativa / afiliado → la propia (fija).
//   • Vista de federación → las de su federación (se elige una).
//   • Vista global → todas las activas (se elige una).
// La elección se recuerda entre pantallas (localStorage). La contabilidad, los
// aportes, el crédito, la nómina, etc. existen POR cooperativa en el backend.

import { useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import useRedReal from './useRedReal';

const CLAVE = 'coopnet_cooperativa_operativa';

export default function useCooperativaOperativa() {
  const { user, contexto } = useAuth();
  const red = useRedReal();

  const fija = user?.nivel === 'cooperativa' || user?.nivel === 'afiliado' ? contexto?.cooperativa?.id || null : null;

  const opciones = useMemo(() => {
    const activas = red.cooperativas.filter((c) => c.activa !== false);
    const lista = user?.nivel === 'federacion' ? activas.filter((c) => c.federacionId === contexto?.federacion?.id) : activas;
    return [...lista].sort((a, b) => a.nombre.localeCompare(b.nombre));
  }, [red.cooperativas, user?.nivel, contexto?.federacion?.id]);

  const [seleccion, setSeleccion] = useState(() => {
    try {
      return localStorage.getItem(CLAVE) || '';
    } catch {
      return '';
    }
  });

  const valida = opciones.some((c) => c.id === seleccion);
  const cooperativaId = fija || (valida ? seleccion : opciones.length === 1 ? opciones[0].id : '') || null;

  const elegir = (id) => {
    setSeleccion(id);
    try {
      localStorage.setItem(CLAVE, id);
    } catch {
      /* sin storage: la elección dura mientras la pantalla esté abierta */
    }
  };

  return {
    cooperativaId,
    cooperativa: red.cooperativas.find((c) => c.id === cooperativaId) || (fija ? contexto?.cooperativa : null) || null,
    seleccionable: !fija,
    opciones,
    elegir,
    cargando: !fija && red.cargando,
    error: red.error,
  };
}
